import React, { useState, useEffect } from "react";
import "./ServerPopup.css";

function ServerPopup(props) {
  const [name, setName] = useState("");
  function handleInputChange(event) {
    setName(event.target.value);
  }

  return (
    <div className="ServerPopup">
      <div className="ServerPopup__popup">
        <input
          type="text"
          value={name}
          onChange={handleInputChange}
          className="ServerPopup__popup__input"
          placeholder={`${
            props.typeFile === "file"
              ? "Введите название файла"
              : "Введите название папки"
          }`}
        />
        <div className="ServerPopup__popup__btns">
          <button className="ServerPopup__popup__btns__btn" onClick={() => {
            props.createFolder(name, props.typeFile, props.pathFile)
          }}>сохранить</button>{" "}
          <button
            onClick={() => {
              props.setIsOpenServerPopup(false);
            }}
            className="ServerPopup__popup__btns__btn"
          >
            отменить
          </button>
        </div>
      </div>
    </div>
  );
}

export default ServerPopup;
